import * as fromDatatype from "../../../../models/datatype-library";

export class DeliveryJobLineReportOutputDto {
    
    item_code:string | any;
    item_name:string | any;
    quantity:string | any;
    uom:string | any;
    trip_no:string | any;
    vehicle_no: string | any;
    driver_name: string | any;
    job_id:string | any;
    start_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
    end_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
    sales_order_no:string | any;
    customer_name:string | any;
    search_keyword: string | any;
}